import React, { useState, useEffect } from 'react'

import { Row, Grid, InputFile } from 'components'
import { IEvidenceItems, DjurServices } from 'services/NGT/DjurServices'
import { FORMAT, SPACING } from 'utils'
import { TableEvidences } from './component'
import { useLoading, useFile, useModal, id } from 'hooks'
import { useDjurService } from '../../../../context'
import { useFormContext, UseFormReturn } from 'react-hook-form'

interface IAttatchEvidence {
  isConsult: boolean
}

const AttachEvidence: React.FC<IAttatchEvidence> = ({ isConsult }) => {
  const { setLoading } = useLoading()
  const { convertFileToBase64 } = useFile()
  const { showModal } = useModal()
  const { state, dispatch } = useDjurService()

  const [tableData, setTableData] = useState<IEvidenceItems[]>([])

  const form: UseFormReturn<any, object> & { errors?: any } = useFormContext()

  const handleAddFile = async (files: FileList) => {
    const file = files[0]
    const base64codeFile = (await convertFileToBase64(file)) as string

    setTableData((prevState) => [
      ...prevState,
      {
        localId: id(),
        evidenciaId: 0,
        nomeArquivo: file.name,
        descricaoArquivo: file.type,
        cdGedExternalId: 0,
        file: base64codeFile,
        idEvidenciaDjur: 0
      }
    ])
  }

  const handleDeleteLocalFile = (localId: string) => {
    setTableData((prevState) =>
      prevState.filter((file) => file.localId !== localId)
    )
  }

  type IDeleteFile = {
    idEvidenciaDjur?: number
    localId?: string
  }
  const handleDeleteFile = (props: IDeleteFile) => {
    if (props.idEvidenciaDjur) {
      handleDeleteUploadedFile(props.idEvidenciaDjur)
      return
    }

    handleDeleteLocalFile(props.localId)
  }

  const getTableDataWithPagination = () => {
    setLoading('loading')

    DjurServices()
      .getInfoAtendimentoDjur({
        flAnexarEvidencias: true,
        idAtendimentoDjur: state?.djurTarget?.idAtendimentoDjur || 0,
        nuProcesso: state?.djurTarget?.processoReclamante || '',
        cpfReclamante: state?.djurTarget?.cpfReclamante || FORMAT.unMask(form.getValues('cpfReclamante'))
        // cpfReclamante: state?.djurTarget?.cpfReclamante || '0',
        // cdContrato: state?.djurTarget?.cdContrato || state.contract.cdContrato,
        // ...(state?.form?.dtFimReclamacao && {
        //   competenciaFim: state?.form?.dtFimReclamacao || '',
        // }),
        // ...(state?.form?.dtFimReclamacao && {
        //   competenciaInicio: state?.form?.dtInicioReclamacao || '',
        // })
      })
      .then((response) => {
        if (response.status !== 200) {
          throw new Error('Erro ao obter as evidências')
        }

        if (response?.data?.anexarEvidencias) {
          setTableData(response.data.anexarEvidencias)
        }
        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          type: 'error',
          message: error.message,
          hideButtonCancel: true,
          txtButtonConfirm: 'OK'
        })
      })
  }

  const handleDeleteUploadedFile = (idEvidenciaDjur: number) => {
    setLoading('loading')
    DjurServices()
      .deleteAnexoEvidencia(idEvidenciaDjur)
      .then((response) => {
        if (response.status !== 200) {
          throw new Error('Não foi possível deletar o arquivo')
        }

        showModal({
          type: 'success',
          message: 'O anexo foi deletado com sucesso!',
          hideButtonCancel: true,
          txtButtonConfirm: 'OK'
        })
        getTableDataWithPagination()
        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          type: 'error',
          message: error.message,
          hideButtonCancel: true,
          txtButtonConfirm: 'OK'
        })
      })
  }

  useEffect(() => {
    getTableDataWithPagination()
  }, [])

  useEffect(() => {
    const isFirstMount = (state.refreshAnexarEvidencias === null) as boolean

    if (!isFirstMount) {
      getTableDataWithPagination()
    }
  }, [state.refreshAnexarEvidencias])

  useEffect(() => {
    dispatch({
      type: 'handleChangeEvidencias',
      payload: tableData.filter((file) => file.localId)
    })
  }, [tableData])

  return (
    <>
      <Row>
        <Grid
          gridCols="3fr 1fr "
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
        >
          {!isConsult && (
            <InputFile
              fileNameProp="name"
              onChange={handleAddFile}
              multiple={false}
            />
          )}
        </Grid>
      </Row>

      <TableEvidences
        isConsult={isConsult}
        tableData={tableData}
        handleDeleteFile={handleDeleteFile}
      />
    </>
  )
}

export default AttachEvidence
